export default __webpack_public_path__ + "static/media/info-mobile.d0c6fe8d.webp";